import { setgroups } from "process";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { dripiconlist } from "src/helpers/iconList";
import { useAppSelector } from "src/store";
import { getExtraServiceGroupListSaga } from "src/store/extra-service-group/saga";
import { ExtraServiceGroupDto } from "src/store/extra-service-group/type";
import { createExtraServiceSaga } from "src/store/extra-service/saga";
import { getPeriodTypes } from "src/store/system/saga";
import { PeriodTypeDto } from "src/store/system/type";
import { getTaxListSaga } from "src/store/tax/saga";
import { TaxDto } from "src/store/tax/type";
import * as Yup from "yup";

const ExtraServiceCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  const [periods, setPeriods] = useState<PeriodTypeDto[]>([]);
  const [groups, setGroups] = useState<ExtraServiceGroupDto[]>([]);
  const [tax, setTax] = useState<TaxDto[]>([]);
  useEffect(() => {
    if (open) {
      dispatch(
        getTaxListSaga({
          payload: {
            onSuccess: (message, payload) => {
              setTax(payload);
            },
            onError: () => {},
          },
        })
      );
      dispatch(
        getExtraServiceGroupListSaga({
          payload: {
            onSuccess: (message, payload) => {
              setGroups(payload);
            },
            onError: () => {},
          },
        })
      );
      dispatch(
        getPeriodTypes({
          payload: {
            onSuccess: (message, payload) => {
              setPeriods(payload);
            },
            onError: () => {},
          },
        })
      );
    }
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("ExtraService.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          PeriodTypeId: "",
          Name: "",
          Price: "",
          Icon: "",
          Vat: "",
          ShowWeb: true,
          ExtraServiceGroupId: "",
          PriceWithTax: false,
          TariffPricing: false,
          Description: "",
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, Name: "", Description: "" };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createExtraServiceSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          Description: Yup.string().required(
            t("Validation.Required").toString()
          ),
          PeriodTypeId: Yup.number().required(
            t("Validation.Required").toString()
          ),
          Price: Yup.number().required(t("Validation.Required").toString()),
          ExtraServiceGroupId: Yup.string().required(
            t("Validation.Required").toString()
          ),
          Icon: Yup.string().required(t("Validation.Required").toString()),
          Vat: Yup.number().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
              Description: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("ExtraService.Name").toString(),
          },
          {
            field: "Description",
            label: t("ExtraService.Description").toString(),
            type: "textarea",
          },
        ]}
        inputs={[
          {
            field: "ExtraServiceGroupId",
            label: t("ExtraService.GroupName").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: groups,
            },
          },
          {
            field: "PeriodTypeId",
            label: t("ExtraService.PeriodType").toString(),
            placeholder: "",
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "EnumId",
              options: periods,
            },
          },
          {
            field: "Icon",
            label: t("ExtraService.Icon").toString(),
            type: "select",
            lookup: {
              renderValue: (e) => <i className={e} />,
              labelKey: "Id",
              valueKey: "Id",
              options: dripiconlist.map((x, i) => {
                return {
                  Id: x,
                  Name: x,
                };
              }),
            },
          },

          {
            field: "Vat",
            col: 6,
            label: t("ExtraService.Tax").toString(),
            type: "select",
            lookup: {
              labelKey: "Value",
              valueKey: "Value",
              options: tax,
            },
          },
          {
            field: "Price",
            label: t("ExtraService.Price").toString(),
            col: 6,
            type: "number",
          },
          {
            field: "PriceWithTax",
            label: t("ExtraService.PriceWithTax").toString(),
            type: "switch",
          },
        ]}
      />
    </React.Fragment>
  );
};
export default ExtraServiceCreateForm;
